import { render, staticRenderFns } from "./RequirementsTree.vue?vue&type=template&id=5c6743a6&"
import script from "./RequirementsTree.vue?vue&type=script&lang=js&"
export * from "./RequirementsTree.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/sebastian/Projekte/CD-Systeme/nextgenkonfi/konfiguratornextgen/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('5c6743a6')) {
      api.createRecord('5c6743a6', component.options)
    } else {
      api.reload('5c6743a6', component.options)
    }
    module.hot.accept("./RequirementsTree.vue?vue&type=template&id=5c6743a6&", function () {
      api.rerender('5c6743a6', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/elements/RequirementsTree.vue"
export default component.exports